import React, { useState } from "react";
import ResetOTP from "../resetPassword/ResetOTP";
import ChangePassword from "../resetPassword/ChangePassword";
import NotificationAlert from "react-notification-alert";
import {
  Card,
  Button,
  CardFooter,
  CardBody,
  FormGroup,
  Input,
  Container,
  Col,
  Form,
  FormFeedback,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { Typography, Box } from "@material-ui/core";
import EmailForm from "./EmailForm";

const ForgotPassword = ({ handleForgotPassword }) => {
  const [otp, setOtp] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isOTPSuccess, setIsOTPSuccess] = useState(false);
  const [newEmail, setNewEmail] = useState('');
  const [isOtpSent,setIsOtpSent]= useState(false);
  const handleOTPSuccess = (newOTP) => {
    setOtp(newOTP);
    setIsOTPSuccess(true);
  };
  const handleEmailSucces=(email)=>{
    setNewEmail(email);
    setIsOtpSent(true)
  }
  return (
    <div className="content">
      {/* {isLoading ? <div className="loading-spinner" /> : ""}
      <div className="rna-container">
        <NotificationAlert ref="notificationAlert" />
      </div> */}
      <Container>
        <Col className="ml-auto mr-auto" lg="4" md="6">
          <div className="login-form">
            <Card className="login-card">
              <div>
                <img
                  src="./plugo-logo.png"
                  style={{
                    width: "70%",
                    display: "block",
                    margin: "0 auto",
                    paddingBottom: "70px",
                  }}
                  alt="Logo"
                />
              </div>
              <CardBody>
                {!isOtpSent ? (
                    <React.Fragment>
                    <EmailForm handleEmailSucces={handleEmailSucces}/>
                    <Box
                  alignItems="center"
                  display="flex"
                  flexDirection="row"
                  justifyContent="flex-start"
                  columnGap={1}
                >
                  <Typography>Want to try to sign in again?</Typography>
                  <Typography
                    variant="button"
                    sx={{ fontWeight: "bold" }}
                    onClick={() => handleForgotPassword()}
                  >
                    {" "}
                    Click here
                  </Typography>
                </Box>
                    </React.Fragment>
                )
              :
                isOTPSuccess ? (
                  <>
                    <ChangePassword otp={otp} email={newEmail} handleForgotPassword={handleForgotPassword}  />
                  </>
                ) : (
                  <>
                    <Box mb={1}>
                      <label>Enter OTP *</label>
                    </Box>
                    <ResetOTP handleOTPSuccess={handleOTPSuccess} />
                  </>
                )}
                
                {/* 'Want to try to sign in again?' */}
              </CardBody>
            </Card>
          </div>
        </Col>
      </Container>
    </div>
  );
};

export default ForgotPassword;
